import { create } from "zustand";

export interface Position {
  id: string;
  symbol: string;
  size: number;
  side: "LONG" | "SHORT";
  entryPrice: number;
  pnl: number;
}

interface PositionsState {
  positions: Record<string, Position[]>;
  isLoading: Record<string, boolean>;
  hasError: Record<string, string | null>;
  setPositions: (accountId: string, positions: Position[]) => void;
  setLoading: (accountId: string, loading: boolean) => void;
  setError: (accountId: string, error: string | null) => void;
}

export const usePositionsStore = create<PositionsState>((set) => ({
  positions: {},
  isLoading: {},
  hasError: {},
  setPositions: (accountId, positions) =>
    set((state) => ({
      positions: { ...state.positions, [accountId]: positions },
      isLoading: { ...state.isLoading, [accountId]: false },
      hasError: { ...state.hasError, [accountId]: null },
    })),
  setLoading: (accountId, loading) =>
    set((state) => ({
      isLoading: { ...state.isLoading, [accountId]: loading },
    })),
  setError: (accountId, error) =>
    set((state) => ({
      hasError: { ...state.hasError, [accountId]: error },
      isLoading: { ...state.isLoading, [accountId]: false },
    })),
}));
